import apiClient from "../utils/ApiClient";

export const AddLegalIformation = async (data) => {    
    try {
        const response = await apiClient.post(
            `/api/add-legal-info`, 
            data);
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};


export const GetLegalInfromation = async () => {
    try {
        const response = await apiClient.get(`/api/add-legal-info-admin`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};
